import {useReducedMotion} from 'framer-motion'

/**
 * Hook to determine if video should autoplay based on prop and user's reduced motion preference
 * @param {boolean} autoplay - Autoplay prop value
 * @returns {boolean} True if video should autoplay (false if user prefers reduced motion)
 */
const useVideoAutoplay = (autoplay) => {
    const prefersReducedMotion = useReducedMotion()
    return autoplay && !prefersReducedMotion
}

export default useVideoAutoplay
